<template>
  <div class="page" ref="outhome">
<!--    <div class="navigation" :class="[value == '/'?'bgwu':'bg8']">-->
    <div class="navigation" :class="[value == '/'?'bg8':'bg8']">
      <div class="in-top flex-hls">
        <img class="nlogo1" src="../assets/img/logo.png" alt="">
        <div class="flex-hlc">
          <div>
            <el-dropdown class="intel1 mr10">
          <span class="el-dropdown-link" @click="newjumpTo(0,'')">
            首页
              <div class="dibucssw" v-if="colorindex === 0"></div>
          </span>
              <el-dropdown-menu slot="dropdown" class="hidden-menu">
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown class="intel1 mr10">
              <!--          <span class="el-dropdown-link" @click="newjumpTo(1,'')">-->
              <span class="el-dropdown-link">
            知识体系<i class="el-icon-arrow-down el-icon-caret-bottom"></i>
              <div class="dibucssw" v-if="colorindex == 1"></div>
          </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for=" (item,idx) in toplist" @click.native="handleCommand(item)">{{
                    item.name
                  }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown class="intel1 mr10">
          <span class="el-dropdown-link" @click="newjumpTo(2,'')">
            平台概况
              <div class="dibucssw" v-if="colorindex == 2"></div>
          </span>
              <el-dropdown-menu slot="dropdown" class="hidden-menu">
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown class="intel1 mr10">
          <span class="el-dropdown-link" @click="newjumpTo(3,'')">
            智能助理
              <div class="dibucssw" v-if="colorindex == 3"></div>
          </span>
              <el-dropdown-menu slot="dropdown" class="hidden-menu">
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown class="intel1 mr10">
          <span class="el-dropdown-link" @click="newjumpTo(6,'')">
            课程案例
              <div class="dibucssw" v-if="colorindex == 6"></div>
          </span>
              <el-dropdown-menu slot="dropdown" class="hidden-menu">
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown class="intel1">
          <span class="el-dropdown-link" @click="newjumpTo(4,'')">
            争鸣论坛
              <div class="dibucssw" v-if="colorindex == 4"></div>
          </span>
              <el-dropdown-menu slot="dropdown" class="hidden-menu">
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="shuge"></div>
          <div v-if="userinfo">
            <el-dropdown class="intel1">
              <span class="el-dropdown-link">
                {{ userinfo.nickname }}<i class="el-icon-arrow-down el-icon-caret-bottom"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="handleinfo(0)">个人信息</el-dropdown-item>
                <el-dropdown-item @click.native="handleinfo(1)">修改密码</el-dropdown-item>
                <el-dropdown-item @click.native="handleinfo(2)">
                  <div class="dingmy">我的论坛
                    <!--                    <div class="dingmured"></div>-->
                  </div>
                </el-dropdown-item>
                <el-dropdown-item @click.native="handleinfo(3)">
                  <div class="dingmy">消息
                    <div class="dingmured" v-if="noread"></div>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown class="intel1">
              <span class="el-dropdown-link" @click="loginoutlook = true">
                退出登录
              </span>
              <el-dropdown-menu slot="dropdown" class="hidden-menu">
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div v-if="!userinfo">
            <el-dropdown class="intel1">
              <span class="el-dropdown-link" @click="tohome(99,'')">
                登录
              </span>
              <el-dropdown-menu slot="dropdown" class="hidden-menu">
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>

    <!--    路由位置-->
    <router-view @cgetnoread="cgetnoread" @changecolor='changecolor' :pushnum="pushnum" :neilist="neilist"
                 :colorindex="colorindex" ref="childData" :key="viewSessionKey + '-' + $route.fullPath"></router-view>
    <!--    <div class="bottomd flex-cc" v-if="value != '/' && value != '/perinfo'  && value != '/login' ">-->
    <!--      <span>© 2025 XXXXXXX版权所有 苏ICP20001245号-1</span>-->
    <!--      <span class="shus"></span>-->
    <!--      <img src="../assets/guohui.png" class="jinghui" alt="">-->
    <!--      <span>苏公网安备35020202012356号</span>-->
    <!--    </div>-->
    <el-dialog
        class="tanpass1 tanpass12"
        append-to-body
        :show-close="false"
        :visible.sync="loginoutlook"
        width="20%">
      <div class="sureout">确定退出登录？</div>
      <div class="w100 flex-cc">
        <div @click="loginoutlook = false" class="quxiaohui mr20">取消</div>
        <div @click="goout()" class="querenlan">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SockJS from 'sockjs-client'
import {Client} from '@stomp/stompjs'
import { clearLoginState, authEventBus } from '@/utils/auth'

let stompClient = null
let audioPlayer = null
const axios = require("axios")
export default {
  data() {
    return {
      // xuanfulist: [{url1: require('../assets/erwei1.png'), url2: require('../assets/erwei2.png')}, {url1: require('../assets/shouji1.png'), url2: require('../assets/shouji2.png')}, {url1: require('../assets/up.png'), url2: require('../assets/up.png')}],
      colorindex: 0,//99时为登录页面100是个人中心0为首页
      bgcolor: 'none',
      outwidth: '100%',
      parentid: '',
      value: '',
      userinfo: '',
      loginoutlook: false,
      pushnum: '',//这里通过参数传递并在子页面监听去刷新页面，在路由里是一个新页面
      timeString: new Date().getTime(),
      toplist: [],//知识动态下拉
      neilist: [],//内部下拉
      noread: false,
      viewSessionKey: 0,
    }

  },

  watch: {
    '$route': 'getPath'
  },
  mounted() {
    authEventBus.$on('logout', this.onAuthLogout)
    this.getdata();//获取下拉列表
    let userinfo = JSON.parse(localStorage.getItem('muiuserinfo') || '{}')?.userInfo || null
    if (userinfo) {
      this.userinfo = userinfo;
      this.getnoread();//获取未读数量（登录后才调用）
      this.connectWebSocket(); // 不再传userId，从token获取
    } else {
      this.userinfo = '';
    }
    // console.log('this.noread', this.noread)

    // this.outwidth = this.$refs.outhome.offsetWidth + 'px'
    // window.onresize = () => {
    //   this.outwidth = this.$refs.outhome.offsetWidth + 'px'
    // }
  },
  beforeDestroy() {
    authEventBus.$off('logout', this.onAuthLogout)
  },
  created() {
    this.parentid = ''
    this.getPath();
  },
  // 22
  methods: {
    onAuthLogout() {
      this.userinfo = ''
      this.noread = false
      this.loginoutlook = false
      this.colorindex = 0
      this.disconnectWebSocket()
      this.viewSessionKey += 1
    },

    cgetnoread() {
      console.log('子集触发111111111')
      this.getnoread();
    },
    // 未读数量
    getnoread() {
      // 检查是否有用户信息，没有则不调用
      let userinfo = JSON.parse(localStorage.getItem('muiuserinfo') || '{}')?.userInfo || null
      if (!userinfo) {
        return;
      }
      let data = {}
      this.$http({
        url: "msg/count",
        method: "POST",
        data: data
      }).then(res => {
        if (res.data.c1 > 0 || res.data.c2 > 0) {
          this.noread = true;
        } else {
          this.noread = false;
        }
      }).catch(err => {
        // 如果调用失败（如未登录），忽略错误
        console.log('获取未读消息失败', err);
      });
    },
    // 退出登录-清楚所有存储，跳转到首页
    goout() {
      clearLoginState()
      this.onAuthLogout()
      this.loginoutlook = false
      if (this.$route.path === '/') {
        window.location.reload()
      } else {
        this.$router.push({ path: '/' })
      }
    },
    changecolor(val) {
      this.colorindex = val;
      localStorage.removeItem('colorindex')
      window.location.reload();
    },
    // 链接websocket
    connectWebSocket() {
      let that = this;
      // 从localStorage获取token
      let userDataStr = localStorage.getItem('muiuserinfo');
      if(!userDataStr) return;
      let userData = JSON.parse(userDataStr);
      let token = userData.token;
      if(!token) return;
      
      // WebSocket连接URL中添加token参数（握手阶段需要）
      const socket = new SockJS(`https://www.esks.com.cn/multimodal/music-ws?token=${token}`)
      stompClient = new Client({
        webSocketFactory: () => socket,
        connectHeaders: {token}, // STOMP连接时也传递token
        debug: () => {
        },
        onConnect: () => {
          // 订阅用户专属消息队列（使用token，不暴露userId）
          stompClient.subscribe(`/topic/token/${token}`, (message) => {
            console.log('播放音乐！！！！！！！！！！！！！', message)
            that.noread = true;
          })
        },
        onStompError: (frame) => {
          console.error('WebSocket错误:', frame.body)
        }
      })

      stompClient.activate()
    },
    // 断开链接
    disconnectWebSocket() {
      if (stompClient) {
        stompClient.deactivate()
        stompClient = null
      }
    },
    // 个人中心-这里也可以用更改传递pushnum的方法
    handleinfo(num) {
      if (this.value == '/perinfo') {//刷新页面-子集有监听
        this.pushnum = this.randomnum();
      } else {
        this.$router.push({
          path: '/perinfo',
        })
      }
      localStorage.setItem('infonum', num);//个人信息的切换靠这个显示
      this.colorindex = 100;//首页靠这个控制
    },
    // 知识动态
    handleCommand(val) {
      // console.log('点击了12222',val,this.$route.query,this.randomnum())
      this.pushnum = this.randomnum();
      // 未登录状态下只有登录和首页可以点击
      // if (!this.userinfo) {
      //   this.$message({
      //     message: '请先进行登录再进行操作！',
      //     type: 'warning',
      //     duration: 2000
      //   });
      //   return false;
      // }
      if (this.userinfo && !this.userinfo.roleId) {
        this.$message({
          message: '暂无角色，请联系管理员！',
          type: 'warning',
          duration: 2000
        });
        return false;
      }
      this.$router.push({
        path: 'knowledge',
        query: {
          parentid: val.id,
          artiid: null
        }
      })
    },
    // 随机数
    randomnum() {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      for (let i = 0; i < 2; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      return result;
    },
    getdata() {
      // this.loading = true;
      let data = {}
      // 未登录状态下只有登录和首页可以点击
      if (!this.userinfo) {
        data.auth = 0
      }else{
        data.auth = 1
      }
      this.$http({
        url: 'category/tree',
        method: 'post',
        data: this.$form(data)
      }).then((res) => {
        this.toplist = res.data.filter(item => item.id != '1988863618597699585');//去掉课程学习
        // console.log('this.toplist', this.toplist)
        let neilist = JSON.parse(JSON.stringify(res.data));
        if (neilist) {
          neilist.forEach((item, index) => {
            if (!item.children) {
              item.disabled = true;
            }
          })
          this.neilist = neilist;
        }
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      })

    },
    // 根据当前路由回显顶部菜单的底部样式
    getPath(v1, v2) {
      let userinfo = JSON.parse(localStorage.getItem('muiuserinfo') || '{}')?.userInfo || null;//回到首页时刷新状态
      if (userinfo) {
        this.userinfo = userinfo;
      } else {
        this.userinfo = '';
      }
      this.value = this.$route.path
      // if(this.$route.path == '/login'){
      //   this.getdata();//获取下拉列表
      // }
      // let colorindex = localStorage.getItem('colorindex');
      console.log('this.首页监听路由', this.$route.path)
      // if (colorindex) {//登录和个人中心存到本地的
      //   this.colorindex = Number(colorindex);
      // } else {
      switch (this.$route.path) {
        case '/':
          this.colorindex = 0
          break;
        case '/knowledge':
          this.colorindex = 1
          break;
        case '/knowledgecourse':
          this.colorindex = 6
          break;
        case '/knowledgesearch':
          this.colorindex = 66
          break;
        case '/statistics':
          this.colorindex = 2
          break;
        case '/AI':
          this.colorindex = 3
          break;
        case '/forum':
          this.colorindex = 4
          break;
        case '/perinfo':
          this.colorindex = 100
          break;
        case '/login':
          this.colorindex = 99
          break;
        default:
          this.colorindex = this.colorindex
          break;
      }
      // }

    },
    tohome() {
      this.colorindex = 99;
      // if (this.value != '/') {
      this.$router.push({
        path: '/login',
      })
      // }
    },
    newjumpTo(val) {
      // console.log('点击了11111', val, this.$route.query)
      this.pushnum = this.randomnum();
      // 未登录状态下只有登录和首页可以点击
      if ((this.colorindex == 99 && val != 0 && val != 99 && val != 6) || (!this.userinfo && val != 0 && val != 99 && val != 6)) {
        this.$message({
          message: '请先进行登录再进行操作！',
          type: 'warning',
          duration: 2000
        });
        return false;
      }
      if (this.userinfo && !this.userinfo.roleId) {
        this.$message({
          message: '暂无角色，请联系管理员！',
          type: 'warning',
          duration: 2000
        });
        return false;
      }
      localStorage.removeItem('colorindex')
      // this.timeString = new Date().getTime();
      this.colorindex = val;
      let data = ''
      switch (val) {
        case 0:
          data = '/'
          break;
        case 1:
          data = '/knowledge'
          break;
        case 2:
          data = '/statistics'
          break;
        case 3:
          data = '/AI'
          break;
        case 4:
          data = '/forum'
          break;
        case 6:
          data = '/knowledgecourse'
          break;
      }
      // if(val == 3){
      //   window.open('https://www.baidu.com/', '_blank');
      // }else{
        this.$router.push({
          path: data,
          query: {
            // pushnum:this.randomnum()
          }
        })
      // }

      return data
    },
  },
  beforeDestroy() {
    this.disconnectWebSocket();
  },
}
</script>

<style lang="scss" scoped>

.tanpass12 {
  margin-top: 28vh;
}

.sureout {
  width: 100%;
  padding: 20px 0;
  font-size: 24px;
  color: white;
  text-align: center;
}

.nlogo1 {
  width: 253px;
  height: auto;
}

.zhanwei {
  width: 100%;
  height: calc(100vh - 60px);
  //background: pink;
}

.dibucssw {
  width: 100%;
  height: 2px;
  position: absolute;
  bottom: 0px;
  left: 0;
  background: white;
  transition: all 0.9s ease-in-out;
  //left: -10px;
}

.dingmy {
  position: relative;
  width: max-content;

  .dingmured {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: red;
    position: absolute;
    bottom: 0;
    right: -10px;
    top: 0;
    margin: auto;
  }
}

.overhidden {
  overflow: hidden;
}

//.el-dropdown-link {
//  font-size: 18px;
//  width: 100%;
//  display: inline-block;
//  overflow: hidden;
//  text-overflow: ellipsis;
//  white-space: nowrap;
//}


.page {
  width: 100%;
  //position: relative;
}

.flex {
  display: flex;
}

.bgwu {
  background: none;
}

.bg8 {
  background-image: url("../assets/img/hangtou.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-bottom: 20px;
}

.navigation {
  width: 100%;
  //background: rgba(0, 0, 0, 0.1);
  //background: #010101;
  //display: flex;
  //justify-content: space-between;
  height: 60px;
  z-index: 99;

  .in-top {
    //width: 1200px;
    width: 100%;
    box-sizing: border-box;
    padding: 6px 30px 0 30px;
    height: 100%;
    margin: 0 auto;

    .shuge {
      width: 1px;
      height: 18px;
      background: white;
      margin: 0 10px;
    }

    .intel1 {
      color: white;
      font-size: 18px;
      height: 60px;
      line-height: 60px;
      box-sizing: border-box;
      padding: 0 15px;
      position: relative;
      cursor: pointer;
      min-width: 90px;
      text-align: center;
    }
  }
}


</style>
